import React from 'react'
import { View, Text, Link } from '@react-pdf/renderer'
import { themeConfig } from '../../config/theme.config'
import SectionTitle from './SectionTitle'
import config from '../../config/config'

const ObjectivesMatrixContent = () => {
  return (
    <View
      style={{
        display: 'flex',
        fontSize: 10,
        gap: 20,
        fontFamily: 'Roboto'
      }}
    >
      <SectionTitle
        sectionTitle="About FHWA’s Proven Safety Countermeasures"
        alignSelf="left"
      />
      <Text style={{ fontFamily: 'Roboto', lineHeight: 1.5 }}>
        FHWA’s Proven Safety Countermeasures are effective strategies to reduce
        roadway fatalities and serious injuries. These strategies are designed
        for all road users and all kinds of roads—from rural to urban, from
        high-volume to less traveled, and everything in between. Each
        countermeasure addresses at least one safety focus area—speed
        management, intersections, roadway departures, or
        pedestrians/bicyclists—while others are crosscutting strategies that
        address multiple safety focus areas. To learn more about FHWA’s Proven
        Safety Countermeasures, visit:
        <Link
          style={{ color: config.themeConfig.semcogBlue1 }}
          src="https://highways.dot.gov/safety/proven-safety-countermeasures"
        >
          https://highways.dot.gov/safety/proven-safety-countermeasures
        </Link>
      </Text>
      <SectionTitle
        sectionTitle="For More Information about the Multimodal Tool"
        alignSelf="left"
      />
      <Text style={{ fontFamily: 'Roboto', lineHeight: 1.5 }}>
        Visit{' '}
        <Link
          style={{ color: config.themeConfig.semcogBlue1 }}
          src="https://www.semcog.org/mmtool"
        >
          https://www.semcog.org/mmtool
        </Link>{' '}
        to learn more about the Multimodal Tool, view the tool user guide, and
        contact SEMCOG about the tool.
      </Text>
    </View>
  )
}
export default ObjectivesMatrixContent
